
import { UserRole } from '@xeetr/types/enums'
import { useContext } from 'react'

import { ActiveUserContext } from '../../context/common/Context'

const useUserRole = (allowed: UserRole | UserRole[]): boolean => {
  const { user } = useContext(ActiveUserContext)

  if (Array.isArray(allowed)) {
    return !!(
      allowed.some((feature) => user?.roles.includes(feature)) ||
      user?.roles.includes(UserRole.DEVELOPER)
    )
  }

  return !!(user?.roles.includes(allowed) || user?.roles.includes(UserRole.DEVELOPER))
}

export default useUserRole
